import React from "react";
import UploadedAttachmentList from "./UploadedAttachmentList";

const DeferredAttachmentSection = ({
  label = "Select File",
  accept = ".pdf,.jpg,.jpeg,.png,.msg",
  multiple = true,
  disabled = false,
  pendingFiles = [],
  uploadedFiles = [],
  onSelectFiles,
  onRemovePendingFile,
  onDeleteUploadedFile,
  getUploadedFileKey,
  getUploadedFileName,
  getUploadedFileUrl,
  getUploadedFileMeta,
  deletingFileId = null,
  pendingTitle = "Files Ready To Save",
  uploadedTitle = "Uploaded Files",
}) => {
  return (
    <>
      <div className="mb-3">
        <label>{label}</label>
        <input
          type="file"
          className="form-control"
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          onChange={onSelectFiles}
        />
      </div>

      {pendingFiles.length > 0 && (
        <div className="mt-4 p-3 bg-light rounded border">
          <div className="text-muted mb-2">{pendingTitle}</div>
          <ul className="list-unstyled mb-0">
            {pendingFiles.map((pendingFile, idx) => (
              <li
                key={`${pendingFile.name}_${pendingFile.size}_${pendingFile.lastModified}_${idx}`}
                className="d-flex justify-content-between align-items-center py-1"
              >
                <span>{pendingFile.name}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemovePendingFile?.(pendingFile)}
                  disabled={disabled}
                  title="Delete"
                >
                  <i className="bi bi-trash"></i>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <UploadedAttachmentList
        title={uploadedTitle}
        files={uploadedFiles}
        getFileKey={getUploadedFileKey}
        getFileName={getUploadedFileName}
        getFileViewUrl={getUploadedFileUrl}
        getFileMeta={getUploadedFileMeta}
        canDelete={Boolean(onDeleteUploadedFile)}
        onDeleteFile={onDeleteUploadedFile}
        deletingFileId={deletingFileId}
      />
    </>
  );
};

export default DeferredAttachmentSection;
